(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2540],{

/***/ 2540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BuildingTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/buildingTypes/buildingTypes.ts
const buildingTypes = {
    residential: [
        {
            path: "garagesOpt",
            title: "Garages"
        },
        {
            path: "aircraft_hangersOpt",
            title: "Aircraft Hangars"
        },
        {
            path: "carportsOpt",
            title: "Carports"
        },
        {
            path: "workshopsOpt",
            title: "Workshops"
        },
        {
            path: "stables_and_arenasOpt",
            title: "Horse Stables & Arenas"
        },
        {
            path: "barnsOpt",
            title: "Barns"
        },
        {
            path: "steel_homesOpt",
            title: "Steel Homes"
        },
        {
            path: "farm_buildingsOpt",
            title: "Farm Buildings"
        }, 
    ],
    commercial: [
        {
            path: "auto_dealershipsOpt",
            title: "Auto Dealerships"
        },
        {
            path: "officesOpt",
            title: "Offices"
        },
        {
            path: "self_storagesOpt",
            title: "Self Storages"
        },
        {
            title: "Recreational Buildings & Covers",
            path: "coversOpt"
        }, 
    ]
};
/* harmony default export */ var buildingTypes_buildingTypes = (buildingTypes);

// EXTERNAL MODULE: ./src/components/steelbuildingestimates/buildingTypes/styles.module.scss
var styles_module = __webpack_require__(38434);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/steelbuildingestimates/buildingTypes/index.tsx




function BuildingTypes() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default()).buildingTypes} py-10 md:py-32`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `flex flex-col mx-auto px-4vw lg:px-4  `,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "font-bold mb-4 mx-auto md:mb-6 text-2xl text-center md:text-4xl ",
                    children: "What Are the Different Types of Steel Buildings?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-6 mx-auto md:mb-10 text-lg text-center md:text-2xl ",
                    children: "Residential:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                    list: buildingTypes_buildingTypes.residential
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-10 mb-6 mx-auto md:mb-10 text-lg text-center md:text-2xl ",
                    children: "Commercial & Industrial:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                    list: buildingTypes_buildingTypes.commercial
                })
            ]
        })
    });
}
function Grid({ list  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 place-items-center md:grid-cols-4 text-center gap-16",
        children: list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-[150px] md:w-[200px] h-[150px] md:h-[200px] ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            src: `/steelbuildingestimates/assets/images/${item.path}.png`,
                            alt: item.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center mt-6 text-gray-500 font-light",
                        children: item.title
                    })
                ]
            }, item.title))
    });
}


/***/ }),

/***/ 38434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","advantages":"styles_advantages__8gEXR"};

/***/ })

}]);